import React from "react";

const DashboardContentFooter = ({ username, handleLogout }) => {
  return (
    <footer className="footer">
      <p>
        &copy; 2025 IDC Portal. All rights reserved. Developed by Islamic
        Diagnostic Center
      </p>
    </footer>
  );
};

export default DashboardContentFooter;
